module.exports = "<button class=\"kd-icon\"\r\n    title=\"Eliminar\"\r\n    ng-click=\"$ctrl.eliminando = true; $event.stopPropagation(); $event.preventDefault();\">\r\n  <i class=\"fa fa-trash\"></i>\r\n</button>\r\n<cliente-informacion-atencion-eliminar-confirmar\r\n    ng-if=\"$ctrl.eliminando\"\r\n    cliente-id=\"$ctrl.clienteId\"\r\n    data=\"$ctrl.data\"\r\n    on-close=\"$ctrl.cerrar($event.detail)\"></cliente-informacion-atencion-eliminar-confirmar>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/cliente/components/informacion/atencion/eliminar/template.html
// module id = 2314
// module chunks = 0